export default __webpack_public_path__ + "static/media/q_w.c106f144.png";